import { render } from "./DeputyAddDropdown.vue?vue&type=template&id=12ad2f16"
import script from "./DeputyAddDropdown.ts?vue&type=script&lang=js&external"
export * from "./DeputyAddDropdown.ts?vue&type=script&lang=js&external"

import "./DeputyAddDropdown.vue?vue&type=style&index=0&id=12ad2f16&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__